/* ==========================================================================
   CL - Vitrina Top - comportamiento
   - Un carrusel por panel (cada pestana tiene su panel)
   - Flechas por pagina, dots clicables, scroll tactil sin JS
   - Bucle sin corte (data-cl-loop="true"): se clonan las ultimas cards al
     inicio y las primeras al final; cuando el scroll se detiene dentro de
     una zona clonada, la pista salta en seco a la posicion equivalente de
     las cards reales. Como las clonadas son identicas y quedan en el mismo
     lugar, el salto no se nota. No es infinito: solo parece.
   - Pestanas: cambian de panel; la pestana picada se desliza a la
     primera posicion de su slider
   - Overlays de degradado: se prenden solo cuando hay contenido
     cortado de ese lado (clases .cl-vtop--fade-left / -right)
   ========================================================================== */

(function () {
	'use strict';

	/* Prende/apaga los degradados de un scroller sobre su contenedor.
	   isLoop(): en bucle siempre hay contenido de los dos lados. */
	function setupFades(scroller, host, isLoop) {
		function update() {
			var canScroll = scroller.scrollWidth > scroller.clientWidth + 8;
			var loop = isLoop ? isLoop() : false;
			/* tolerancia de 8px: el scroll-snap asienta el track unos px
			   por el padding interno */
			var atStart = scroller.scrollLeft <= 8;
			var atEnd =
				scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 8;
			host.classList.toggle('cl-vtop--fade-left', canScroll && (loop || !atStart));
			host.classList.toggle('cl-vtop--fade-right', canScroll && (loop || !atEnd));
		}
		scroller.addEventListener('scroll', update, { passive: true });
		update();
		return update;
	}

	/* Salto sin animacion aunque el track tenga scroll-behavior: smooth */
	function jumpTo(track, x) {
		try {
			track.scrollTo({ left: x, behavior: 'instant' });
		} catch (e) {
			var prev = track.style.scrollBehavior;
			track.style.scrollBehavior = 'auto';
			track.scrollLeft = x;
			track.style.scrollBehavior = prev;
		}
	}

	/* ---------- Bucle sin corte ---------- */
	function createLoop(track, cardSel, enabled) {
		var state = { on: false, k: 0, total: 0, step: 0 };

		function realCards() {
			return Array.prototype.filter.call(track.querySelectorAll(cardSel), function (c) {
				return !c.classList.contains('is-clone');
			});
		}

		function clearClones() {
			track.querySelectorAll(cardSel + '.is-clone').forEach(function (c) {
				c.parentNode.removeChild(c);
			});
		}

		function makeClone(card) {
			var c = card.cloneNode(true);
			c.classList.add('is-clone');
			c.setAttribute('aria-hidden', 'true');
			c.removeAttribute('data-shopify-editor-block');
			if (c.tagName === 'A' || c.tagName === 'BUTTON') c.setAttribute('tabindex', '-1');
			c.querySelectorAll('a, button, [tabindex]').forEach(function (el) {
				el.setAttribute('tabindex', '-1');
			});
			return c;
		}

		/* Indice (fraccionario) de la card real que esta al inicio de la vista */
		function realIndex() {
			if (!state.step) return 0;
			if (!state.on) return track.scrollLeft / state.step;
			var i = track.scrollLeft / state.step - state.k;
			return ((i % state.total) + state.total) % state.total;
		}

		/* Crea o rehace las clonadas segun cuantas cards caben; conserva la
		   card real que se estaba viendo. */
		function build(m) {
			var cards = realCards();
			var total = cards.length;
			var need = enabled && total > m.perView && m.cardStep > 0;
			var k = need ? Math.min(total, m.perView + 2) : 0;
			var cur = realIndex();
			if (k === state.k && total === state.total && state.on === need) {
				state.step = m.cardStep;
				return;
			}
			clearClones();
			if (need) {
				var head = document.createDocumentFragment();
				var tail = document.createDocumentFragment();
				cards.slice(-k).forEach(function (c) { head.appendChild(makeClone(c)); });
				cards.slice(0, k).forEach(function (c) { tail.appendChild(makeClone(c)); });
				track.insertBefore(head, track.firstChild);
				track.appendChild(tail);
			}
			state.on = need;
			state.k = k;
			state.total = total;
			state.step = m.cardStep;
			jumpTo(track, (k + Math.max(0, Math.round(cur))) * m.cardStep);
		}

		/* Llamar cuando el scroll se detiene: si quedo en zona clonada,
		   brinca a la posicion equivalente entre las cards reales. */
		function settle() {
			if (!state.on || !state.step) return false;
			var x = track.scrollLeft;
			var span = state.total * state.step;
			var minX = (state.k - 0.5) * state.step;
			var maxX = (state.k + state.total - 0.5) * state.step;
			if (x >= maxX) {
				jumpTo(track, x - span);
				return true;
			}
			if (x < minX) {
				jumpTo(track, x + span);
				return true;
			}
			return false;
		}

		return { state: state, build: build, settle: settle, realIndex: realIndex, realCards: realCards };
	}

	function initCarousel(panel, loopEnabled) {
		var viewport = panel.querySelector('.cl-vtop__viewport');
		var track = panel.querySelector('.cl-vtop__track');
		var prev = panel.querySelector('.cl-vtop__arrow--prev');
		var next = panel.querySelector('.cl-vtop__arrow--next');
		var dotsWrap = panel.querySelector('.cl-vtop__dots');
		if (!track || !viewport) return null;

		var loop = createLoop(track, '.cl-vtop__card', loopEnabled);

		function metrics() {
			var card = track.querySelector('.cl-vtop__card');
			if (!card) return null;
			var styles = window.getComputedStyle(track);
			var gap = parseFloat(styles.columnGap || styles.gap) || 0;
			var cardStep = card.offsetWidth + gap;
			var perView = Math.max(1, Math.floor(track.clientWidth / cardStep));
			var total = loop.realCards().length;
			var pages = Math.max(1, Math.ceil(total / perView));
			return { cardStep: cardStep, perView: perView, total: total, pages: pages };
		}

		function pageWidth(m) {
			return m.cardStep * m.perView;
		}

		function currentPage(m) {
			var idx = loop.state.on ? loop.realIndex() : track.scrollLeft / m.cardStep;
			return Math.round(idx / m.perView) % m.pages;
		}

		function positionArrows() {
			var media = track.querySelector('.cl-vtop__media');
			if (!media) return;
			panel.style.setProperty('--cl-vtop-arrow-top', (8 + media.offsetHeight / 2) + 'px');
		}

		function updateArrows() {
			if (!prev || !next) return;
			if (loop.state.on) {
				prev.disabled = false;
				next.disabled = false;
				return;
			}
			var maxScroll = track.scrollWidth - track.clientWidth - 2;
			prev.disabled = track.scrollLeft <= 2;
			next.disabled = track.scrollLeft >= maxScroll;
		}

		function buildDots() {
			if (!dotsWrap) return;
			var m = metrics();
			if (!m) return;
			dotsWrap.innerHTML = '';
			if (m.pages <= 1) {
				dotsWrap.style.display = 'none';
				return;
			}
			dotsWrap.style.display = '';
			for (var i = 0; i < m.pages; i++) {
				var li = document.createElement('li');
				var btn = document.createElement('button');
				btn.type = 'button';
				btn.className = 'cl-vtop__dot';
				btn.setAttribute('role', 'tab');
				btn.setAttribute('aria-label', 'Ir a la pagina ' + (i + 1));
				btn.dataset.page = i;
				btn.addEventListener('click', function () {
					var mm = metrics();
					var p = parseInt(this.dataset.page, 10);
					var base = loop.state.on ? loop.state.k * mm.cardStep : 0;
					track.scrollTo({ left: base + p * pageWidth(mm), behavior: 'smooth' });
				});
				li.appendChild(btn);
				dotsWrap.appendChild(li);
			}
			updateDots();
		}

		function updateDots() {
			if (!dotsWrap) return;
			var m = metrics();
			if (!m) return;
			var active = currentPage(m);
			dotsWrap.querySelectorAll('.cl-vtop__dot').forEach(function (d, i) {
				d.classList.toggle('cl-vtop__dot--active', i === active);
				d.setAttribute('aria-selected', i === active ? 'true' : 'false');
			});
		}

		var updateFades = setupFades(track, viewport, function () { return loop.state.on; });

		/* Navegacion por pagina con destino absoluto: si se pica varias
		   veces seguidas, cada clic suma una pagina al destino pendiente en
		   vez de medir desde donde va la animacion. Si el destino cae fuera
		   de la zona clonada, primero se brinca (sin que se note) al tramo
		   equivalente y luego se anima. */
		var pending = null;
		function go(dir) {
			var m = metrics();
			if (!m) return;
			var base = pending !== null ? pending : Math.round(track.scrollLeft / m.cardStep);
			var target = base + dir * m.perView;
			if (loop.state.on) {
				/* Solo se brinca si la posicion equivalente existe; si no,
				   el destino se queda en la zona clonada y settle() brinca
				   al terminar la animacion. */
				var tot = loop.state.total;
				var span = tot * m.cardStep;
				var maxX = track.scrollWidth - track.clientWidth;
				if (target >= loop.state.k + tot && track.scrollLeft - span >= 0) {
					jumpTo(track, track.scrollLeft - span);
					target -= tot;
				} else if (target < 0 && track.scrollLeft + span <= maxX) {
					jumpTo(track, track.scrollLeft + span);
					target += tot;
				}
			}
			var maxIdx = Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / m.cardStep));
			target = Math.max(0, Math.min(maxIdx, target));
			pending = target;
			pendingSince = Date.now();
			track.scrollTo({ left: target * m.cardStep, behavior: 'smooth' });
		}
		if (prev) prev.addEventListener('click', function () { go(-1); });
		if (next) next.addEventListener('click', function () { go(1); });

		/* Al detenerse el scroll: brinco del bucle (si toca) y refresco de UI */
		var touching = false;
		track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
		track.addEventListener('touchend', function () {
			touching = false;
			scheduleSettle();
		}, { passive: true });
		track.addEventListener('touchcancel', function () { touching = false; }, { passive: true });

		var scrollTimer;
		var pendingSince = 0;
		function onSettle() {
			if (touching) return;
			/* Si hay un destino de flecha pendiente y todavia no llegamos
			   (p. ej. el brinco previo disparo scrollend antes de que
			   arrancara la animacion), esperar; no brincar a medio camino. */
			if (pending !== null) {
				var m = metrics();
				var dist = m ? Math.abs(track.scrollLeft - pending * m.cardStep) : 0;
				if (m && dist > m.cardStep * 0.5 && Date.now() - pendingSince < 1500) {
					scheduleSettle();
					return;
				}
				pending = null;
			}
			loop.settle();
			updateArrows();
			updateDots();
		}
		function scheduleSettle() {
			window.clearTimeout(scrollTimer);
			scrollTimer = window.setTimeout(onSettle, 90);
		}
		track.addEventListener('scroll', scheduleSettle, { passive: true });
		if ('onscrollend' in window) {
			track.addEventListener('scrollend', function () {
				window.clearTimeout(scrollTimer);
				onSettle();
			});
		}

		function refresh() {
			var m = metrics();
			if (m && track.clientWidth > 0) loop.build(m);
			positionArrows();
			updateArrows();
			buildDots();
			updateFades();
		}

		refresh();
		return { refresh: refresh };
	}

	function initVitrinaTop(root) {
		if (!root || root.dataset.clInit === 'true') return;
		root.dataset.clInit = 'true';

		var loopEnabled = root.getAttribute('data-cl-loop') !== 'false';
		var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cl-panel]'));
		var carousels = panels.map(function (p) {
			return initCarousel(p, loopEnabled);
		});

		/* ---------- Pestanas ---------- */
		var tabsWrap = root.querySelector('.cl-vtop__tabs-wrap');
		var tabsScroller = root.querySelector('.cl-vtop__tabs');
		var tabs = root.querySelectorAll('.cl-vtop__tab');
		var updateTabFades = null;

		if (tabsScroller && tabsWrap) {
			updateTabFades = setupFades(tabsScroller, tabsWrap);

			tabs.forEach(function (tab, i) {
				tab.addEventListener('click', function () {
					tabs.forEach(function (t, j) {
						t.classList.toggle('cl-vtop__tab--active', i === j);
						t.setAttribute('aria-selected', i === j ? 'true' : 'false');
					});
					panels.forEach(function (p, j) {
						if (i === j) {
							p.removeAttribute('hidden');
						} else {
							p.setAttribute('hidden', '');
						}
					});
					/* Los paneles ocultos no tienen medidas: recalcular al mostrar */
					if (carousels[i]) carousels[i].refresh();
					/* La pestana picada se desliza a la primera posicion */
					tabsScroller.scrollTo({
						left: Math.max(0, tab.offsetLeft - 2),
						behavior: 'smooth'
					});
				});
			});
		}

		var resizeTimer;
		window.addEventListener('resize', function () {
			window.clearTimeout(resizeTimer);
			resizeTimer = window.setTimeout(function () {
				panels.forEach(function (p, i) {
					if (!p.hasAttribute('hidden') && carousels[i]) carousels[i].refresh();
				});
				if (updateTabFades) updateTabFades();
			}, 150);
		}, { passive: true });
	}

	function initAll() {
		document.querySelectorAll('.cl-vtop').forEach(initVitrinaTop);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
